import React, { useState, useEffect } from 'react';
import { Drawer, Form, Input, Button, message, Select, Card, Spin, Checkbox, Tooltip, Row, Col, Cascader, Radio } from 'antd';
import { BASE_URL, helpTextFormula } from '../Components/Constant';
import { InfoCircleOutlined, PlusOutlined, MinusCircleOutlined, QuestionCircleOutlined } from '@ant-design/icons'; // Import the InfoCircle icon
import FiltersDynamic from '../Components/FiltersDynamicComponent';
import GenericAddRemoveMultipleRecords from '../SetupComponent/GenericAddRemoveMultipleRecordsUI'; // Import the generic component
import ApiService from '../Components/apiService'; // Import ApiService class
import pluralize from 'pluralize';
import TextArea from 'antd/es/input/TextArea';
import DynamicPicklistComponent from '../Components/MultiSelectPicklistComponent';
import CustomDrawer from '../Components/CustomDrawer';
import { columnDropStyleBordered } from 'ag-grid-community';

const { Option } = Select;

const CreateFieldDrawer = ({
  visible,
  onClose,
  onAddField,
  mtObjectId,
  editField,
  onSaveEdit,
  mtObjectName,
  currentStep,
  setCurrentStep
}) => {
  const [form] = Form.useForm();
  const [fieldType, setFieldType] = useState('');
  const [isAutoNumber, setIsAutoNumber] = useState(false); // State for auto number checkbox
  const [isFormula, setIsFormula] = useState(false); // State for auto number checkbox
  const [isRollUp, setIsRollUp] = useState(false); // State for auto number checkbox
  const [picklistValues, setPicklistValues] = useState([]);
  const [availableObjects, setAvailableObjects] = useState([]);
  const [loading, setLoading] = useState(false); // Spinner state
  const isEditMode = !!editField; // Check if it's edit mode
  const [fieldForFormula, setFieldsforFormula] = useState([]);
  const [formula, setFormula] = useState('');
  const [isValidFormula, setIsValidFormula] = useState(null); // null means not checked yet
  const [validationMessage, setValidationMessage] = useState(null);
  const [selectedCC, setSelectedCC] = useState([]);
  const [isRequired, setIsRequired] = useState(false); // State for auto number checkbox
  const [isUnique, setIsUnique] = useState(false); // State for auto number checkbox
  const [isExternalId, setIsExternalID] = useState(false); // State for auto number checkbox
  const [isFieldTrackingEnabled, setIsFieldTrackingEnabled] = useState(false);
  const [ParentObjectFields, setParentObjectFields] = useState([]);
  const [relationships, setRelationships] = useState([]);
  const [selectedRelationshipName, setSelectedRelationshipName] = useState('');
  const [childObjectFields, setChildObjectFields] = useState([]);
  const [aggregationField, setAggregationField] = useState('');
  const [aggregationOperator, setAggregationOperator] = useState('');
  const [fetchedFields, setFetchedFields] = useState(null);
  const [childObjectAllFields, setChildObjectAllFields] = useState([]);
  const [formulaType, setFormulaType] = useState(null);
  const [rollUpType, setRollUpType] = useState(null);
  const [logic, setLogic] = useState('');
  const [operator, setOperator] = useState('AND');
  const [isLogicEditable, setIsLogicEditable] = useState(false);
  const [filters, setFilters] = useState([{ 1: { field: '', value: '', displayValue: '' } }]); // For managing filters
  const [valueOperator, setValueOperator] = useState('');
  const [parentfieldlookupOptions, setParentFieldLookupOptions] = useState([]); // For storing lookup options
  const [fieldsToDisplayLookupConfig, setFieldsToDisplayLookupConfig] = useState([]);
  const [searchLayoutLookupConfig, setSearchLayoutLookupConfig] = useState([]);
  const [isDependentDeletion, setIsDependentDeletion] = useState(false);
  const [rollUpFiltersFields, setRollUpFiltersFields] = useState([]);
  const [rollUpFilters, setRollUpFilters] = useState([]);
  const [logicForROllUpFilters, setLogicForRollUpFilters] = useState('');
  const [valueOperatorForRollUpFilters, setValueOperatorForRollUpFilters] = useState('');
  const [sourceObjectForRollUp, setSourceObjectForRollUp] = useState(null);
  const [groupByFieldForRollUp, setGroupByFieldForRollUp] = useState(null);
  const [AvailableGroupFieldsForRollUp, setAvailableGroupFieldsForRollUp] = useState([]);
  const [lookupOptionsForRollUpFilters, setLookupOptionsForRollUpFilters] = useState([]);
  const [lookupOptionsForLookupField, setLookupOptionsForLookupField] = useState([]);
  const [accessPolicies, setAllAccessPolicy] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [parentlookupOptions, setParentLookupOptions] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [expandedLookupField, setExpandedLookupField] = useState(null);
  const [parentFieldsMap, setParentFieldsMap] = useState({});


  // Utility function to sanitize label and create API name
  const generateApiName = (label) => {
    return label
      .replace(/[^a-zA-Z]/g, '') // Remove all characters except letters (a-z, A-Z)
      .replace(/\s+/g, '')       // Remove all spaces
      .trim();
  };
  //To reset form and call the onClose method from parent..
  const handleCancel = () => {
    setIsFormula(false);
    setIsRollUp(false);
    setIsAutoNumber(false);
    setIsRequired(false);
    setIsExternalID(false);
    setIsUnique(false);
    setIsFieldTrackingEnabled(false);
    setSelectedCC([]);
    setPicklistValues([]);
    setFieldType('');
    setRelationships([]);
    setChildObjectFields([]);
    setChildObjectAllFields([]);
    setFetchedFields(null);
    setSelectedRelationshipName('');
    setAggregationField('');
    setAggregationOperator('');
    setRollUpFilters(null);
    setRollUpFiltersFields(null);
    setGroupByFieldForRollUp(null);
    setLogicForRollUpFilters('');
    setLookupOptionsForRollUpFilters(null);
    setSourceObjectForRollUp(null);
    setFormulaType(null);
    setFormula(null);
    setRollUpType(null);

    form.resetFields(); // Reset fields when the cancel button is clicked
    onClose(); // Close the drawer
  };

  // Handle label change and update API name
  const handleLabelChange = (e) => {
    const label = e.target.value;
    const currentApiName = form.getFieldValue('name');


    // Only set the name if the field is not a lookup
    if (!isEditMode && !currentApiName) {
      form.setFieldsValue({
        name: generateApiName(label), // Set the API name based on the sanitized label
      });
    }
  };

  const fetchParentObject = async (objectName) => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/mt_fields/object/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      setFieldsforFormula(response);
    } catch (error) {
      console.error("Error fetching relationships:", error);
    }
  };
  // Fetch available objects for the lookup field
  useEffect(() => {
    if (fieldType === 'formula') {
      setIsFormula(true);
      fetchParentObject(mtObjectName);
    } else if (fieldType === 'rollup') {
      setIsRollUp(true);
    }
    else {
      setIsRollUp(false);
      setIsFormula(false);
    }
    const fetchAvailableObjects = async () => {
      try {
        const objectService = new ApiService(`${BASE_URL}/mt_objects`, {}, 'GET');
        const response = await objectService.makeCall();
        setAvailableObjects(response);
      } catch (error) {
        message.error('Failed to fetch objects');
      }
    };
    fetchAvailableObjects();

  }, [fieldType]);

  useEffect(() => {

    const fetchAccessPolicy = async () => {
      try {
        const accessPolicyService = new ApiService(`${BASE_URL}/mt_access_policies`, {}, 'GET');
        const response = await accessPolicyService.makeCall();
        console.log("Access Policy", response);
        setAllAccessPolicy(response);
      } catch (error) {
      }
    }

    if (!editField) {
      fetchAccessPolicy();


    }
  }, []);


  useEffect(() => {
    if (editField && (rollUpFilters !== null || rollUpFiltersFields !== undefined)) {
      fetchLookupRecordsForExistingFilters(rollUpFilters);
    }
  }, [rollUpFiltersFields]);

  useEffect(() => {
    if (editField && (filters !== null || filters !== undefined)) {
      fetchLookupRecordsForExistingFiltersLookupField(filters);
    }
  }, [ParentObjectFields])


  // Initialize the form in edit mode
  useEffect(() => {
    if (editField) {
      const existingFilters = editField?.lookup_config?.filter_criteria
        ? Object.entries(editField?.lookup_config?.filter_criteria).map(([key, { field, value }]) => {
          let operator = '';
          let actualValue = '';

          if (Object.keys(value)[0] !== "0") {
            operator = Object.keys(value)[0];
            actualValue = value[operator];

          } else {
            actualValue = value; // Extract the actual value (e.g., '50')

          }
          let op = '';
          if (operator !== '') {
            try {
              setValueOperator(operator);
              op = operator;
            } catch (error) {
              // Handle the error gracefully
              setValueOperator(''); // or any default value
            }
          } else {
            op = '';
          }
          return {
            field,
            value: value,
            displayValue: actualValue,
            operator: op
          };
        })
        : [{ field: '', value: '', operator: '' }];

      const existingFiltersForRollUp = editField?.rollUp_config?.filters
        ? Object.entries(editField?.rollUp_config?.filters).map(([key, { field, value }]) => {
          let operator = '';
          let actualValue = '';

          if (Object.keys(value)[0] !== "0") {
            operator = Object.keys(value)[0];
            actualValue = value[operator];

          } else {
            actualValue = value; // Extract the actual value (e.g., '50')

          }
          let op = '';
          if (operator !== '') {
            try {
              setValueOperatorForRollUpFilters(operator);
              op = operator;
            } catch (error) {
              // Handle the error gracefully
              setValueOperatorForRollUpFilters(''); // or any default value
            }
          } else {
            op = '';
          }
          return {
            field,
            value: value,
            displayValue: actualValue,
            operator: op
          };
        })
        : [{ field: '', value: '', operator: '' }];
      form.setFieldsValue({
        ...editField,
        length: editField?.decimal_places_before + editField?.decimal_places_after, // Calculate total length
        decimal_places: editField?.decimal_places_after, // Set decimal places
        format: editField?.auto_number_format,
        startingPoint: editField?.auto_number_starting,
        description: editField?.description,
        helpText: editField?.help_text,
        defaultValue: editField?.default_value,
        required: editField?.required,
        unique: editField?.unique,
        external_id: editField?.external_id,
        field_Tracking: editField?.track_field_history,
        ImageWidth: editField?.image_config?.width,
        ImageHeight: editField?.image_config?.height,
        picklist_values: editField?.picklist_values,
        ...(editField?.type === 'rollup' && {
          aggregationOperator: editField?.rollUp_config.aggregation_type,
          AggregationField: editField?.rollUp_config.aggregation_field,
          relationshipToRollup: editField?.relationship_name,
          group_by_field: editField?.rollUp_config?.group_by_field?.replace(/_id$/, ''),
          source_object: getApiName(editField?.rollUp_config?.source_object),
        }),
      });
      if (editField?.is_formula) {
        form.setFieldsValue({
          type: 'formula',
          return_type: editField?.type,
        })
      }
      if (editField?.is_rollup) {
        form.setFieldsValue({
          type: 'rollup',
          rollup_return_type: editField?.rollup_return_type,
        })
      }
      setSearchLayoutLookupConfig(editField?.lookup_config?.search_layout);
      setFieldsToDisplayLookupConfig(editField?.lookup_config?.display_fields);

      setFilters(existingFilters || {});
      setLogic(editField?.lookup_config?.logic_string)
      setIsFormula(editField?.is_formula)
      setIsRollUp(editField?.is_rollup)
      setFormula(editField?.formula)
      setSelectedCC(editField?.compliance_categorization)
      setFieldType(editField?.is_formula ? 'formula' : editField?.type); // Set field type for conditional rendering
      setIsAutoNumber(editField?.is_auto_number || false); // Set auto number state if editing
      setIsRequired(editField?.required || false); // Set auto number state if editing
      setIsUnique(editField?.unique || false); // Set auto number state if editing
      setIsExternalID(editField?.external_id || false); // Set auto number state if editing
      setIsFieldTrackingEnabled(editField?.track_field_history)
      setFormulaType(editField?.is_formula ? editField?.type : null);
      if (editField?.type === 'lookup') {
        handleParentObjectChange(editField?.parent_object_name);
        fetchLookupRecordsForExistingFiltersLookupField(existingFilters);
      }
      setIsDependentDeletion(editField?.dependent_delete || false);
      if (editField?.type === 'rollup') {
        setRollUpType(editField?.rollUp_config?.rollUpType);
        setAggregationField(editField?.rollUp_config?.aggregation_field);
        setAggregationOperator(editField?.rollUp_config?.aggregation_type);
        const sourceobject = getApiName(editField?.rollUp_config?.source_object);
        handleSourceObjectChange(sourceobject);
        fetchLookupRecordsForExistingFilters(existingFiltersForRollUp);
        const groupByField = editField?.rollUp_config?.group_by_field?.replace(/_id$/, '');
        setGroupByFieldForRollUp(groupByField);
        setRollUpFilters(existingFiltersForRollUp || {});
        setLogicForRollUpFilters(editField?.rollUp_config?.logic_string);
        fetchLookupRecordsForExistingFilters(existingFiltersForRollUp);
      }
      if (editField?.type === 'picklist' || editField?.type === 'multiselect') {
        setPicklistValues(editField?.picklist_values);
      }
    } else {
      form.resetFields(); // Reset fields for creating a new field
      setIsAutoNumber(false); // Reset auto number state
      setIsFormula(false);
      setIsRollUp(false);
      setIsRequired(false);
      setIsExternalID(false);
      setIsUnique(false);
      setIsFieldTrackingEnabled(false);
      setSelectedCC([]);
      setPicklistValues([]);
    }
  }, [editField, form]);

  const handlePicklistChange = (values) => {
    //const values = event.target.value.split(',').map(value => value.trim());
    setPicklistValues(values);
  };

  function getPluralLabel(name) {
    return name?.replace(/([a-z])([A-Z])/g, '$1_$2') // Convert camelCase to snake_case
      .replace(/\s+/g, '_') // Replace spaces with underscores
      .toLowerCase() + 's'; // Convert to lowercase and add 's'
  }

  function getApiName(pluralLabel) {
    // Remove the trailing 's' correctly
    let singular = pluralLabel?.replace(/s$/, '') // Removes the last 's'
      .replace(/_/g, ' '); // Replace underscores with spaces

    return singular?.split(' ') // Split by spaces
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize each word
      .join(''); // Join into PascalCase          
  }

  const handleFinish = async (values, saveAndNew = false) => {
    if (Number(values?.decimal_places) === 0) {
      message.error("Decimal places should be greater than 0");
      return;
    }


    const lookupConfig = {
      display_fields: fieldsToDisplayLookupConfig,
      search_layout: searchLayoutLookupConfig,
      logic_string: logic,
      filter_criteria: filters?.reduce((acc, filter, index) => {
        if (filter?.field) {
          acc[index + 1] = {
            field: filter.field,
            value: filter.value
          };
        }
        return acc;
      }, {})
    };

    const img_config = {
      width: values?.ImageWidth,
      height: values?.ImageHeight
    };

    const filtersForRollUp = rollUpFilters?.reduce((acc, filter, index) => {
      if (filter?.field) {
        acc[index + 1] = {
          field: filter.field,
          value: filter.operator && filter.value === ""
            ? { [filter.operator]: "" }  // If operator exists and value is empty, set as JSON object
            : filter.value
        };
      }
      return acc;
    }, {});

    const rollUpConfig = {
      aggregation_type: values?.aggregationOperator,
      rollUpType: values?.rollUptype,
      aggregation_field: values?.AggregationField,
      group_by_field: groupByFieldForRollUp ? `${groupByFieldForRollUp}` : null,
      // target_object: getPluralLabel(mtObjectName),
      target_object: mtObjectName,
      // source_object: getPluralLabel(sourceObjectForRollUp),
      source_object: sourceObjectForRollUp,
      filters: filtersForRollUp,
      logic_string: logicForROllUpFilters

    }



    if (isFormula) {
      const error = validateFormulaSyntax(formula);
      if (error) {
        message.error(`Formula syntax is invalid. ${error}`);
        return;
      }
    }

    setLoading(true); // Show spinner

    console.log('values///', values);
    const newField = {
      label: values.label,
      name: values.name,
      type: values.type === 'formula' ? formulaType : values.type,
      mt_object_id: mtObjectId,
      iseditable: values.iseditable || true,
      iswriteable: values.iswriteable || true,
      is_auto_number: isAutoNumber,
      is_formula: isFormula,
      is_rollup: isRollUp,
      rollup_return_type: rollUpType,
      description: values.description,
      help_text: values.helpText,
      default_value: values.defaultValue,
      required: isRequired,
      unique: isUnique,
      external_id: isExternalId,
      track_field_history: isFieldTrackingEnabled,
    };

    if (values.type === 'string' || values.type === 'picklist') {
      newField.compliance_categorization = selectedCC
    }

    if (values.type === 'lookup') {
      newField.parent_object_name = values.parent_object_name;
      newField.relationship_name = values.relationship_name;
      newField.lookup_config = lookupConfig;
      newField.dependent_delete = isDependentDeletion;
    }
    if (isAutoNumber) {
      newField.auto_number_format = values.format; // Add starting point
      newField.auto_number_starting = values.startingPoint;     // Add ending point
    }

    if (isFormula) {
      newField.formula = formula;
    }

    if (values.type === 'picklist' || values.type === 'multiselect') {
      newField.picklist_values = picklistValues;
    }

    if (values.type === 'decimal' || values.type === 'currency' || values.type === 'percentage') {
      newField.decimal_places_before = values.length;
      newField.decimal_places_after = values.decimal_places;
    }

    if (values.type === 'rollup') {
      newField.rollUp_config = rollUpConfig;
    }
    if (values.type === "image") {
      newField.image_config = img_config;
    }



    try {
      if (isEditMode) {
        // Update field logic (PUT request)
        const fieldService = new ApiService(`${BASE_URL}/mt_fields/${editField._id}`, {}, 'PUT', {
          mt_field: newField,
        });
        const response = await fieldService.makeCall();
        onSaveEdit({ ...editField, ...values }); // Update the field in the parent component

        message.success('Field updated successfully');
      } else {
        console.log("New Field", newField);
        // Create new field logic (POST request)
        const fieldService = new ApiService(`${BASE_URL}/mt_fields`, {}, 'POST', {
          mt_field: {
            ...newField
          },
          access_params: { "policy_ids": selectedItems }
        });


        const response = await fieldService.makeCall();

        onAddField({
          key: Date.now(),
          label: values.label,
          name: values.name,
          type: values.type === 'formula' ? formulaType : values.type,
          iseditable: values.iseditable,
          iswriteable: values.iswriteable,
          is_formula: isFormula,
          is_rollup: isRollUp,
          rollup_return_type: rollUpType,
          is_auto_number: isAutoNumber,
          description: values.description,
          help_text: values.helpText,
          default_value: values.defaultValue,
          required: isRequired,
          unique: isUnique,
          external_id: isExternalId,
          track_field_history: isFieldTrackingEnabled,
          ...((values.type === 'picklist' || values.type === 'string') && {
            compliance_categorization: selectedCC
          }),
          ...(isAutoNumber && { auto_number_format: values.format, auto_number_starting: values.startingPoint }),
          ...(values.type === 'picklist' || values.type === 'multiselect' && { picklist_values: picklistValues }),
          ...(values.type === 'decimal' || values.type === 'percentage' || values.type === 'currency' && {
            decimal_places_before: values.length,
            decimal_places_after: values.decimal_places,
          }),
          ...(values.type === 'lookup' && {
            parent_object_name: values.parent_object_name,
            relationship_name: values.relationship_name,
            lookup_config: lookupConfig,
            dependent_delete: isDependentDeletion
          }),
          ...(isFormula && { formula: formula }),
          ...(values.type === 'image' && { image_config: img_config }),

        });

        message.success('Field created successfully');

      }

      if (!saveAndNew) {
        onClose(); // Close the drawer for regular save
        form.resetFields();
      } else {
        form.resetFields(); // Reset the form for new object creation
      }
      setIsAutoNumber(false); // Reset auto number state
      setIsFormula(false);
      setIsRollUp(false);
      setIsRequired(false);
      setIsExternalID(false);
      setIsUnique(false);
      setIsFieldTrackingEnabled(false);
      setIsDependentDeletion(false);
      setSelectedCC([]);
      setFieldType('');
      setRelationships([]);
      setChildObjectFields([]);
      setChildObjectAllFields([]);
      setFetchedFields(null);
      setSelectedRelationshipName('');
      setAggregationField('');
      setAggregationOperator('');
      setFieldsToDisplayLookupConfig([]);
      setRollUpFilters(null);
      setRollUpFiltersFields(null);
      setGroupByFieldForRollUp(null);
      setLogicForRollUpFilters('');
      setLookupOptionsForRollUpFilters(null);
      setSourceObjectForRollUp(null);
      setFormulaType(null);
      setFormula(null);
      setRollUpType(null);
      setPicklistValues([]);
      setSelectedItems([]);

    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save field due to an unknown error';
      message.error(errorMessage);
    } finally {
      setLoading(false); // Hide spinner
      setCurrentStep(1);
    }
  };

  const fetchParentLookupFields = async (field) => {
    const parentObject = field.parent_object_name;

    if (!parentObject) return;

    // If already cached, skip API call
    if (parentFieldsMap[field.name]) {
      return;
    }

    const res = await new ApiService(
      `${BASE_URL}/mt_fields/object/${parentObject}`,
      { 'Content-Type': 'application/json' },
      'GET'
    ).makeCall();

    setParentFieldsMap(prev => ({
      ...prev,
      [field.name]: res   // store fields using field.name
    }));
  };


  console.log('editfiel;d', editField);

  const cascaderOptions = fieldForFormula
    ?.filter((field) => !(field.name === "recordCount" || field.name === editField?.name))
    ?.map((field) => {
      if (field.type === 'lookup') {

        const cachedChildren = parentFieldsMap[field.name];

        return {
          label: field.label,
          value: field.name,
          isLeaf: false,
          children: cachedChildren
            ? cachedChildren
              ?.filter((child) => child.name !== "recordCount")
              .map((child) => ({
                label: child.label,
                value: `${field.name}.${child.name}`,
              }))
            : [] // empty until we fetch
        };
      }

      return {
        label: field.label,
        value: field.name,
      };
    });



  const validateFormulaSyntax = (formula) => {
    // Check balanced parentheses
    const stack = [];
    for (const char of formula) {
      if (char === '(') {
        stack.push(char);
      } else if (char === ')') {
        if (stack.length === 0) {
          return "Unbalanced parentheses.";
        }
        stack.pop();
      }
    }
    if (stack.length > 0) {
      return "Unbalanced parentheses.";
    }

    // Check for invalid operator placement
    const operatorRegex = /[\+\-\*\/]/;
    if (operatorRegex.test(formula[0]) || operatorRegex.test(formula[formula.length - 1])) {
      return "Formula cannot start or end with an operator.";
    }
    if (/[\+\-\*\/]{2,}/.test(formula)) {
      return "Operators cannot be consecutive.";
    }

    // If all checks pass
    return null;
  };

  const handleFormulaChange = (value) => {
    const selectedObject = form.getFieldValue('object_for_formula');

    // List of simple operators
    const operators = ["+", "-", "*", "/", "^", "(", ")"];

    let valueToInsert;



    // 👉 If it's an operator, insert directly
    valueToInsert = value;


    // 👉 Otherwise treat it as a field name


    setFormula(formula.concat(valueToInsert));
  };



  const validateFormula = () => {
    const error = validateFormulaSyntax(formula);
    if (error) {
      setValidationMessage(error);
      setIsValidFormula(false);
    } else {
      setValidationMessage("Formula syntax is correct.");
      setIsValidFormula(true);
    }
  };

  const handleComplianceCategorizationChange = (value) => {
    setSelectedCC(value);
  };

  const handleParentObjectChange = async (value) => {
    try {

      const apiService = new ApiService(
        `${BASE_URL}/mt_fields/object/${value}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      const filteredFields = response.filter(field => field.name !== 'recordCount' &&
        // field.type !== 'Lookup' && 
        !field.is_formula); // Filter out 'recordCount'

      setParentObjectFields(filteredFields);
    } catch (error) {
      console.error("Error fetching fields:", error);
    }
  };

  const handleSetFieldType = (value) => {
    setFieldType(value);
    if (value !== 'string') {
      setIsAutoNumber(false); // Reset auto number checkbox if type is not String
    }

  }

  const fetchObjectFields = async (objectId) => {
    try {
      const apiService = new ApiService(
        `${BASE_URL}/get_fields_by_objectId/${objectId}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiService.makeCall();
      return response;
    } catch (error) {
      console.error('Error fetching fields:', error);
      message.error('Failed to fetch fields');
    }
  };

  const handleAggregationOperatorChange = async (value) => {
    setAggregationOperator(value);
    if (value) {
      if (!fetchedFields) {
        const relationship = relationships.find(rel => rel.relationship_name === selectedRelationshipName);
        if (relationship) {
          const objectId = relationship.mt_object_id;
          const objectFields = await fetchObjectFields(objectId);
          // const allObjectFields = objectFields;
          if (objectFields && objectFields.length > 0) {
            // const allObjectFields = objectFields.filter(field => field.name !== 'recordCount');
            const allObjectFields = [{ name: '_id', label: 'Id' }]; //For now only the _id field is allowed. Uncomment the above line for future use to allow all fields
            setChildObjectAllFields(allObjectFields);
            const integerFields = objectFields.filter(field => (field.type === 'integer' || field.type === 'decimal' || field.type === 'currency') && field.name !== 'recordCount');

            setChildObjectFields(integerFields);
            setFetchedFields(integerFields);
          } else {
          }
        } else {
        }
      } else {
        setChildObjectFields(fetchedFields);
      }
    }
  };

  const handleFieldsToDisplayLookupConfig = (value) => {

    setFieldsToDisplayLookupConfig(value);

  }

  const handleSearchLayoutLookupConfig = (value) => {
    setSearchLayoutLookupConfig(value);
  }

  const handleSourceObjectChange = async (value) => {
    setSourceObjectForRollUp(value);
    try {

      const objectService = new ApiService(`${BASE_URL}/mt_fields/object/${value}`, {}, 'GET');
      const response = await objectService.makeCall();
      const filteredFields = response.filter(field => field.name !== 'recordCount');
      setRollUpFiltersFields(filteredFields);
      const filtered = response.filter(
        field => (field.type === 'lookup' && field.parent_object_name === mtObjectName)
      );
      setAvailableGroupFieldsForRollUp(filtered);
      const allObjectFields = [{ name: '_id', label: 'Id' }]; //For now only the _id field is allowed. Uncomment the above line for future use to allow all fields
      setChildObjectAllFields(allObjectFields);
      const integerFields = response.filter(field => (field.type === 'integer' || field.type === 'decimal' || field.type === 'currency') && field.name !== 'recordCount');
      setChildObjectFields(integerFields);


    }
    catch (error) {

    }


  }

  const fetchLookupRecordsForExistingFilters = (existingFilters) => {
    existingFilters?.forEach(filter => {
      const selectedField = rollUpFiltersFields?.find(field => field.name === filter.field.replace('_id', ''));
      if (selectedField && selectedField.type === 'lookup') {
        fetchLookupRecords(selectedField.parent_object_name); // Fetch records for lookup fields
      }
    });
  };

  const fetchLookupRecordsForExistingFiltersLookupField = (existingFilters) => {
    existingFilters?.forEach(filter => {
      const selectedField = ParentObjectFields?.find(field => field.name === filter.field.replace('_id', ''));
      if (selectedField && selectedField.type === 'lookup') {
        fetchLookupRecordsLookup(selectedField.parent_object_name); // Fetch records for lookup fields
      }
    });
  };

  const fetchLookupRecords = async (objectName) => {
    try {

      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForRecords.makeCall();
      // Assuming response is an array of records with _id and Name fields
      const records = response.map(record => ({
        value: record._id,
        label: record.Name,
        displayValue: record.Name
      }));
      setLookupOptionsForRollUpFilters(records);

    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save field due to an unknown error';
      message.error(errorMessage);
    }
  };

  const fetchLookupRecordsLookup = async (objectName) => {
    try {
      const apiServiceForRecords = new ApiService(
        `${BASE_URL}/fetch_records/${objectName}`,
        { 'Content-Type': 'application/json' },
        'GET'
      );
      const response = await apiServiceForRecords.makeCall();
      // Assuming response is an array of records with _id and Name fields
      const records = response.map(record => ({
        value: record._id, // Set _id as value
        label: record.Name, // Set Name as label
        displayValue: record.Name

      }));
      setLookupOptionsForLookupField(records);

    } catch (error) {
      const errorMessage = error && typeof error === 'object'
        ? Object.entries(error).map(([key, value]) => `${key}: ${Array.isArray(value) ? value.join(', ') : value}`).join(' | ')
        : 'Failed to save field due to an unknown error';
      message.error(errorMessage);
    }
  };

  return (
    <CustomDrawer
      title={isEditMode ? 'Edit Field' : 'Create New Field'}
      visible={visible}
      zIndex={1002}   // higher than sidebar
      onClose={!loading ? onClose : null} // Prevent drawer from closing when loading is true
      closable={false}
      footer={
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
          <Button onClick={onClose} disabled={loading}>Cancel</Button>
          <div>
            {!editField && currentStep === 2 && (
              <Button onClick={() => setCurrentStep(1)} disabled={loading} style={{ marginRight: '5px' }}>Prev</Button>
            )}
            {!editField && currentStep === 1 && (
              <Button type="primary"
                onClick={() => {
                  console.log("Form values", form.getFieldsValue());
                  setFormValues(form.getFieldsValue());
                  form.validateFields().then(() => setCurrentStep(2))
                }}>
                Next
              </Button>
            )}
            {(editField || currentStep === 2) && (
              <>
                {!editField && (
                  <Button style={{ marginRight: '8px' }}
                    disabled={loading}
                    onClick={() => {
                      form.validateFields().then((values) => {
                        handleFinish(editField ? form.getFieldsValue() : formValues, true); // Pass a flag to differentiate Save & New
                      });
                    }}>
                    Save & New
                  </Button>
                )}
                <Button type="primary"
                  disabled={loading}
                  onClick={() => {
                    console.log("values", formValues);
                    form.validateFields().then(() => handleFinish(editField ? form.getFieldsValue() : formValues), false);
                  }}
                >
                  Save
                </Button>
              </>
            )}
          </div>
        </div>
      }
    >
      <Spin spinning={loading}> {/* Spinner */}
        <Form
          form={form}
          layout="vertical"
          hideRequiredMark
          onFinish={handleFinish}
          style={{ fontSize: '12px' }}
        >
          {currentStep === 1 && (
            <>
              <Form.Item
                name="type"
                label="Type"
                rules={[{ required: true, message: 'Please select the type' }]}
              >
                <Select
                  showSearch
                  placeholder="Select the field type"
                  disabled={editField}
                  onChange={(value) => {
                    handleSetFieldType(value);
                  }}
                >
                  <Option value="string">Text</Option>
                  <Option value="integer">Number</Option>
                  <Option value="decimal">Decimal</Option>
                  <Option value="email">Email</Option>
                  <Option value="currency">Currency</Option>
                  <Option value="boolean">Boolean</Option>
                  <Option value="address">Address</Option>
                  <Option value="date">Date</Option>
                  <Option value="datetime">Date Time</Option>
                  <Option value="percentage">Percentage (%)</Option>
                  <Option value="phone">Phone</Option>
                  <Option value="picklist">Picklist</Option>
                  <Option value="multiselect">Multi-Select Picklist</Option>
                  <Option value="lookup">Lookup</Option>
                  <Option value="textarea">Text Area</Option>
                  <Option value="url">URL</Option>
                  <Option value="image">Image</Option>
                  <Option value="richtext">Rich-Text</Option>
                  <Option value="rollup">Roll-Up</Option>
                  <Option value="formula">Formula</Option>
                </Select>
              </Form.Item>

              <Form.Item
                name="label"
                label="Label"
                rules={[{ required: true, message: 'Please enter a label' }]}
              >
                <Input onBlur={handleLabelChange} placeholder="Enter label" />
              </Form.Item>

              <Form.Item
                name="name"
                label="API Name"
                rules={[
                  { required: true, message: 'Please enter the name' },
                  {
                    validator: (_, value) => {
                      if (!value) {
                        return Promise.resolve();
                      }
                      const alphabetOnlyRegex = /^[a-zA-Z]+$/;
                      if (!alphabetOnlyRegex.test(value)) {
                        return Promise.reject(new Error('Name should only contain alphabets without spaces.'));
                      }
                      if (!/^[A-Z]/.test(value)) {
                        return Promise.reject(new Error('Name should start with a capital letter.'));
                      }
                      if (pluralize.isPlural(value)) {
                        return Promise.reject(new Error('API name cannot be plural.'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
              >

                <Input placeholder="Please enter the name" disabled={isEditMode} />

              </Form.Item>

              {fieldType === 'image' && ( // Only show for String type
                <>
                  <Form.Item
                    name="ImageWidth"
                    label="Image Width"
                    rules={[{ required: true, message: 'Please enter the image width' }]}
                  >
                    <Input placeholder="Enter image width" type="number" />

                  </Form.Item>
                  <Form.Item
                    name="ImageHeight"
                    label="Image Height"
                    rules={[{ required: true, message: 'Please enter the image height' }]}
                  >
                    <Input placeholder="Enter image height" type="number" />

                  </Form.Item>

                </>
              )}

              {fieldType === 'rollup' && (
                <>
                  {/* <Form.Item
                      name="rollup_return_type"
                      label="RollUp Return Type"
                      rules={[{ required: true, message: 'Please select RollUp type' }]}
                    >
                      <Select
                        placeholder="Select RollUp type"
                        onChange={(value) => setRollUpType(value)} // store in state
                        style={{ width: '100%' }}
                        disabled={editField}

                      >
                        <Option value="date">Date</Option>
                        <Option value="dateTime">DateTime</Option>
                        <Option value="boolean">Boolean</Option>
                        <Option value="integer">Integer</Option>
                        <Option value="float">Float</Option>
                        <Option value="string">String</Option>
                        <Option value="decimal">Decimal</Option>
                        <Option value="currency">Currency</Option>
                      </Select>
                    </Form.Item> */}

                  <Form.Item
                    name="source_object"
                    label="Source Object"
                    rules={[{ required: true, message: 'Please select an object' }]}
                  >
                    <Select placeholder="Select an object" value={sourceObjectForRollUp} onChange={handleSourceObjectChange}>
                      {availableObjects.map((obj) => (
                        <Option key={obj.name} value={obj.name}>
                          {obj.label}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="group_by_field"
                    label="Group by fields"
                    rules={[{ required: true, message: 'Please select an object' }]}
                  >
                    <Select placeholder="Select field" value={groupByFieldForRollUp} onChange={(e) => setGroupByFieldForRollUp(e)}>
                      {AvailableGroupFieldsForRollUp.map((field) => (
                        <Option key={field.name} value={field.name}>
                          {field.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>


                  <Form.Item
                    name="aggregationOperator"
                    label="Aggregation Operator"
                    rules={[{ required: true, message: 'Please select an Operator' }]}
                  >
                    <Radio.Group onChange={(e) => handleAggregationOperatorChange(e.target.value)}>
                      <Radio value="count">Count</Radio>
                      <Radio value="sum">Sum</Radio>
                      <Radio value="min">Min</Radio>
                      <Radio value="max">Max</Radio>
                    </Radio.Group>
                  </Form.Item>

                  {aggregationOperator && (
                    <Form.Item
                      name="AggregationField"
                      label="Aggregation Field"
                      rules={[{ required: true, message: 'Please select a field' }]}
                    >
                      <Select placeholder="Select a field"
                        onChange={(selectedFieldName) => {
                          setAggregationField(selectedFieldName);

                          const availableFields = aggregationOperator === 'count'
                            ? childObjectAllFields
                            : childObjectFields;

                          const selectedField = availableFields.find(field => field.name === selectedFieldName);
                          console.log('selectedFieldselectedField', selectedField);
                          if (selectedField?.type) {
                            setRollUpType(selectedField.type);
                          } else if (aggregationOperator === 'count') {
                            setRollUpType('integer');
                          } else {
                            setRollUpType(null); // fallback if nothing matches
                          }
                        }}
                        disabled={!aggregationOperator}
                      >
                        {(aggregationOperator === 'count' ? childObjectAllFields : childObjectFields).map((field) => (
                          <Option key={field.id} value={field.name}>
                            {field.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  )}
                  <FiltersDynamic
                    fields={rollUpFiltersFields}
                    logic={logicForROllUpFilters}
                    setLogic={setLogicForRollUpFilters}
                    filters={rollUpFilters}
                    setFilters={setRollUpFilters}
                    setValueOperator={setValueOperatorForRollUpFilters}
                    valueOperator={valueOperatorForRollUpFilters}
                    fetchLookupRecordsForExistingFilters={fetchLookupRecordsForExistingFilters}
                    fetchLookupRecords={fetchLookupRecords}
                    lookupOptions={lookupOptionsForRollUpFilters}
                  >

                  </FiltersDynamic>
                </>
              )}

              {(fieldType === 'string' || fieldType === 'formula') && (
                <>
                  {/* Show Auto Number only when not Formula type */}
                  {fieldType !== 'formula' && (
                    <Form.Item name="autoNumber">
                      <Checkbox
                        checked={isAutoNumber}
                        onChange={(e) => setIsAutoNumber(e.target.checked)}
                        disabled={isFormula}
                      >
                        Auto Number
                      </Checkbox>
                    </Form.Item>
                  )}

                  {/* Optional: Show Is Formula checkbox only when fieldType is String */}
                  {/* {fieldType === 'String' && (
              <Form.Item name="is_formula">
                <Checkbox
                  checked={isFormula}
                  onChange={(e) => setIsFormula(e.target.checked)}
                  disabled={isAutoNumber}
                >
                  Is Formula
                </Checkbox>
              </Form.Item>
            )} */}
                </>
              )}


              {isFormula && (
                <>
                  <Form.Item
                    name="return_type"
                    label="Formula Return Type"
                    rules={[{ required: true, message: 'Please select formula type' }]}
                  >
                    <Select
                      placeholder="Select formula type"
                      onChange={(value) => setFormulaType(value)} // store in state
                      style={{ width: '100%' }}
                      disabled={editField}

                    >
                      <Option value="date">Date</Option>
                      <Option value="dateTime">DateTime</Option>
                      <Option value="boolean">Boolean</Option>
                      <Option value="integer">Integer</Option>
                      <Option value="float">Float</Option>
                      <Option value="string">String</Option>
                      <Option value="decimal">Decimal</Option>
                      <Option value="currency">Currency</Option>
                    </Select>
                  </Form.Item>


                  <Row gutter={16}>
                    <Col span={12}>


                      <Form.Item
                        name="field_for_formula"
                        label="Insert Field"
                      >


                        <Cascader
                          placeholder="Select field"
                          allowClear={false}
                          size="middle"
                          style={{ width: "100%" }}

                          // When selecting, insert the LAST part
                          onChange={(value) => {
                            console.log("Inserting field:", value[value.length - 1]);
                            handleFormulaChange(value[value.length - 1]);
                            setDropdownOpen(false);
                          }}

                          // When expanding a lookup field, fetch children
                          loadData={async (selectedOptions) => {
                            const selected = selectedOptions[0];
                            const lookupField = fieldForFormula.find(f => f.name === selected.value);

                            if (lookupField?.type === "lookup") {
                              await fetchParentLookupFields(lookupField);
                            }
                          }}

                          options={cascaderOptions}
                        />

                      </Form.Item>

                    </Col>


                    <Col span={12}>
                      <Form.Item
                        name="operator_for_formula"
                        label="Insert Operator"
                      >
                        <Select placeholder="Insert Operator" onChange={(e) => handleFormulaChange(e)}>
                          <Option value="+">+ Add</Option>
                          <Option value="-">- Subtract</Option>
                          <Option value="*">* Multiply</Option>
                          <Option value="/">/ Divide</Option>
                          <Option value="^">^ Exponentiation</Option>
                          <Option value="(">( Open Parenthesis</Option>
                          <Option value=")">) Close Parenthesis</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Row align="middle" gutter={8}>
                    <Col flex="auto">
                      <TextArea value={formula} onChange={(e) => setFormula(e.target.value)} placeholder="Enter formula" />
                    </Col>
                    <Col>
                      <Tooltip title={helpTextFormula} placement="right">
                        <InfoCircleOutlined style={{ color: '#1890ff', cursor: 'pointer' }} />
                      </Tooltip>
                    </Col>
                  </Row>

                  <Button type="default" onClick={validateFormula} style={{ marginRight: 8, marginTop: 4 }}>
                    Check Status
                  </Button>

                  {isValidFormula !== null && (
                    <div style={{ marginTop: '10px', color: isValidFormula ? 'green' : 'red' }}>
                      {validationMessage}
                    </div>
                  )}
                </>
              )}


              {isAutoNumber && ( // Only show these fields if isAutoNumber is checked
                <>
                  <Form.Item
                    name="format"
                    label={
                      <span>
                        Format&nbsp;
                        <Tooltip title="Enter the format using placeholders like {0000} for the auto-incremented number. Example: INV-{0000} for invoice numbers.">
                          <InfoCircleOutlined style={{ color: '#1890ff' }} />
                        </Tooltip>
                      </span>
                    } rules={[
                      { required: true, message: 'Please enter the format!' },
                      {
                        pattern: /^[^\{\}]*\{0+\}$/,
                        message: 'Format should follow the pattern INV-{0000}!'
                      }
                    ]}
                  >
                    <Input placeholder="Enter format" />
                  </Form.Item>
                  <Form.Item
                    name="startingPoint"
                    label="Starting Point"
                    rules={[{ required: true, message: 'Please enter the starting point!' }]}
                  >
                    <Input type="number" placeholder="Enter starting point" />
                  </Form.Item>
                </>
              )}


              {(fieldType === 'picklist' || fieldType === 'multiselect') && ( // Only show for Picklist type
                <Form.Item
                  name="picklist_values"
                  label={
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      Picklist Values
                      <Tooltip
                        title={
                          <div>
                            <ul style={{ paddingLeft: "16px", margin: 0 }}>
                              <li>Enter comma-separated values</li>
                              <li>Press Enter or + to add</li>
                            </ul>
                          </div>
                        }
                      >
                        <QuestionCircleOutlined style={{ cursor: "pointer", color: "#1890ff" }} />
                      </Tooltip>
                    </div>
                  }
                  rules={[{ required: true, message: 'Please input the picklist values!' }]}
                >
                  <DynamicPicklistComponent selectedFields={picklistValues} onChange={handlePicklistChange} isSelect={false} />
                </Form.Item>
              )}

              {fieldType === 'decimal' || fieldType === 'percentage' || fieldType === 'currency' ? ( // Only show for decimal and currency types
                <>
                  <Form.Item
                    name="length"
                    label="Length"
                    rules={[{ required: true, message: 'Please enter the length!' }]}
                  >
                    <Input
                      placeholder="Enter total length"
                      type="number"
                      onWheel={(e) => e.target.blur()} // Prevents scrolling from changing the value
                    />
                  </Form.Item>
                  <Form.Item
                    name="decimal_places"
                    label="Decimal Places"
                    rules={[{ required: true, message: 'Please enter the decimal places!' }]}
                  >
                    <Input
                      placeholder="Enter decimal places"
                      type="number"
                      onWheel={(e) => e.target.blur()} // Prevents scrolling from changing the value
                    />
                  </Form.Item>
                </>
              ) : null}

              {fieldType === 'lookup' && (
                <>

                  <Form.Item
                    name='dependent_delete'>
                    <Checkbox
                      checked={isDependentDeletion}
                      onChange={(e) => setIsDependentDeletion(e.target.checked)}
                      disabled={isAutoNumber}
                    >
                      Dependent Deletion
                    </Checkbox >

                  </Form.Item>
                  <Form.Item
                    name="parent_object_name"
                    label="Parent Object Name"
                    rules={[{ required: true, message: 'Please enter parent object name' }]}
                  >
                    <Select showSearch placeholder="Select an object" disabled={isEditMode} onChange={(e) => handleParentObjectChange(e)}>
                      {availableObjects.map((object) => (
                        <Option key={object.id} value={object.name}>
                          {object.name}
                        </Option>
                      ))}
                    </Select>

                  </Form.Item>

                  <Form.Item
                    name="relationship_name"
                    label="Relationship Name"
                    rules={[
                      { required: true, message: 'Please enter the name' },
                      {
                        validator: (_, value) => {
                          if (!value) {
                            return Promise.resolve();
                          }
                          const alphabetOnlyRegex = /^[a-zA-Z]+$/;
                          if (!alphabetOnlyRegex.test(value)) {
                            return Promise.reject(new Error('Name should only contain alphabets without spaces.'));
                          }
                          if (pluralize.isPlural(value)) {
                            return Promise.reject(new Error('API name cannot be plural.'));
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input disabled={editField} placeholder="Please enter relationship name" />

                  </Form.Item>

                  <Form.Item
                    name="fieldsToDisplay"
                    label="Fields to Display"
                  >

                    <DynamicPicklistComponent
                      onChange={handleFieldsToDisplayLookupConfig}
                      isSelect={true}
                      selectedFields={fieldsToDisplayLookupConfig}
                      selectOptions={ParentObjectFields}
                    ></DynamicPicklistComponent>


                  </Form.Item>

                  <Form.Item
                    name="SearchLayout"
                    label="Search layout"
                  >
                    <DynamicPicklistComponent
                      onChange={handleSearchLayoutLookupConfig}
                      isSelect={true}
                      selectedFields={searchLayoutLookupConfig}
                      selectOptions={ParentObjectFields}
                    ></DynamicPicklistComponent>


                  </Form.Item>

                  <FiltersDynamic

                    fields={ParentObjectFields}
                    logic={logic}
                    setLogic={setLogic}
                    filters={filters}
                    setFilters={setFilters}
                    setValueOperator={setValueOperator}
                    valueOperator={valueOperator}
                    fetchLookupRecordsForExistingFilters={fetchLookupRecordsForExistingFiltersLookupField}
                    fetchLookupRecords={fetchLookupRecordsLookup}
                    lookupOptions={lookupOptionsForLookupField}
                  >

                  </FiltersDynamic>

                </>
              )}

              {!isAutoNumber &&
                (fieldType === 'string' || fieldType === 'picklist') && (
                  <Form.Item
                    name="complianceCategorization"
                    label="Compliance Categorization"
                  >
                    <Select
                      mode="multiple"
                      placeholder="Select compliance categorization"
                      onChange={handleComplianceCategorizationChange}
                      defaultValue={selectedCC}
                      value={selectedCC}
                    >
                      <Option value="PII">PII</Option>
                      <Option value="HIPAA">HIPAA</Option>
                      <Option value="GDPR">GDPR</Option>
                      <Option value="PCI">PCI</Option>
                      <Option value="COPPA">COPPA</Option>
                      <Option value="CCPA">CCPA</Option>
                    </Select>
                  </Form.Item>
                )}

              {!isFormula && !isAutoNumber && (
                <>
                  <Form.Item
                    name="description"
                    label="Description"
                  >
                    <Input.TextArea placeholder="Enter description" />
                  </Form.Item>

                  <Form.Item
                    name="helpText"
                    label="Help Text"
                  >
                    <Input.TextArea placeholder="Enter help text" />
                  </Form.Item>

                  {fieldType !== 'lookup' || fieldType !== 'rollup' && (
                    <Form.Item
                      name="defaultValue"
                      label="Default Value"
                    >
                      <Input placeholder="Enter default value" type="text" />
                    </Form.Item>
                  )}

                  {!(fieldType === 'rollup' || fieldType === 'boolean' || isAutoNumber || isFormula) && (
                    <Form.Item name="required" >
                      <Checkbox
                        checked={isRequired}
                        onChange={(e) => setIsRequired(e.target.checked)}
                      >Required
                      </Checkbox>
                    </Form.Item>
                  )}

                  {(fieldType === 'string' || fieldType === 'integer' || fieldType === 'decimal' || fieldType === 'email' || fieldType === 'phone') && (
                    <Form.Item name="unique">
                      <Checkbox
                        checked={isUnique}
                        onChange={(e) => setIsUnique(e.target.checked)}
                      >Unique</Checkbox>
                    </Form.Item>
                  )}
                  {(fieldType === 'string' || fieldType === 'integer' || fieldType === 'decimal' || fieldType === 'email') && (
                    <Form.Item name="external_id" >
                      <Checkbox
                        checked={isExternalId}
                        onChange={(e) => setIsExternalID(e.target.checked)}
                      >External Id</Checkbox>
                    </Form.Item>
                  )}


                  {(fieldType !== 'richtext' && fieldType !== 'textarea' && fieldType !== 'image') && (
                    <Form.Item name="field_Tracking" >
                      <Checkbox
                        checked={isFieldTrackingEnabled}
                        onChange={(e) => setIsFieldTrackingEnabled(e.target.checked)}
                      >Enable Field Tracking</Checkbox>
                    </Form.Item>
                  )}
                </>
              )}

            </>
          )}

        </Form>

        {!editField && currentStep === 2 && (
          <GenericAddRemoveMultipleRecords
            titleLeft="Available Access Policies"
            titleRight="Selected Access Policies"
            dataSource={accessPolicies}
            selectedKeys={selectedItems}
            onUpdateSelectedKeys={setSelectedItems}
            columnsLeft={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
            columnsRight={[{ title: 'Name', dataIndex: 'Name', key: 'Name' }]}
            searchFields={['Name']}
          />

        )}

      </Spin>
    </CustomDrawer>
  );
};

export default CreateFieldDrawer;
